import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Construction } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BetaNotice } from '@/components/BetaNotice';
import Navigation from '@/components/Navigation';

const CreateLeague = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Create New League</h1>
          <p className="text-muted-foreground">
            League creation is coming soon!
          </p>
        </div>

        <BetaNotice 
          variant="beta"
          title="Future Enhancement"
          description="League creation is currently under development. This feature will be available in a future update. For now, leagues are managed on MusicLeague.com and displayed here for a better user experience."
          className="mb-6"
        />

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Construction className="h-5 w-5 text-muted-foreground" />
              Under Construction
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center py-12">
            <div className="mb-6">
              <Construction className="h-16 w-16 mx-auto text-muted-foreground mb-4" />
              <h3 className="text-xl font-semibold mb-2">Coming Soon</h3>
              <p className="text-muted-foreground mb-4">
                League creation functionality is currently under development and will be available in a future update.
              </p>
              <p className="text-sm text-muted-foreground">
                In the meantime, leagues are managed on MusicLeague.com and can be viewed here for a more user-friendly experience.
              </p>
            </div>
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default CreateLeague;
